var n;!function(n){n.ERROR="error",n.WARNING="warning",n.INFO="info",n.DEBUG="debug",n.EVENT="event",n.LOG="log"}(n||(n={}));export{n as LogLevel};
//# sourceMappingURL=type.js.map
